import { render, staticRenderFns } from "./TransferListTable.vue?vue&type=template&id=15cb6a23&scoped=true&"
import script from "./TransferListTable.vue?vue&type=script&lang=js&"
export * from "./TransferListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cb6a23",
  null
  
)

export default component.exports